import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    continue: 'Continue',
    inputs: {
      nafCode: {
        errors: {
          invalidCode: 'The NAF code doesn’t exist',
          invalidFormat:
            'The NAF code format is invalid (it must be 4 digits + 1 letter long)',
        },
        help: 'Four digits and one letter (ex: 6920Z).\nYou can find it on your company registration paper.',
        label: 'NAF / APE Code',
      },
      registrationDate: {
        errors: {
          invalid: 'The registration date is invalid',
          maxValue: 'The registration date cannot be in the future',
        },
        label: 'Registration Date',
      },
      siret: {
        errors: {
          invalid: 'The SIRET is invalid',
        },
        help: 'The 14 digit legal registration for your business',
        label: 'SIRET',
      },
    },
    save: 'Save',
    title: {
      add: 'Complete your company’s legal information',
      edit: 'Modify your company’s legal information',
    },
  },
  fr: {
    continue: 'Continuer',
    inputs: {
      nafCode: {
        errors: {
          invalidCode: 'Ce code APE n’existe pas',
          invalidFormat:
            'Le format du code NAF est invalide (il doit comporter 4 chiffres + 1 lettre)',
        },
        help: '4 chiffres et une lettre (ex\u00A0: 6920Z)\nVous pouvez le trouver sur le document confirmant la création de votre entreprise',
        label: 'Code NAF / APE',
      },
      registrationDate: {
        errors: {
          invalid: 'La date de création est invalide',
          maxValue: 'La date de création ne peut pas être dans le futur',
        },
        label: 'Date de création',
      },
      siret: {
        errors: {
          invalid: 'Le SIRET est invalide',
        },
        help: 'Il s’agit du numéro d’immatriculation de votre entreprise à 14 chiffres',
        label: 'SIRET',
      },
    },
    save: 'Enregistrer',
    title: {
      add: 'Ajouter les informations juridiques de votre entreprise',
      edit: 'Modifier les informations juridiques de votre entreprise',
    },
  },
} as const);
